"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegTweaksTmpChangeT = exports.LegTweaksTmpChange = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
/**
 * Makes a temporary change to legtweaks. This is not saved to disk, and can be
 * cleared with `LegTweaksTmpClear`
 */
class LegTweaksTmpChange {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsLegTweaksTmpChange(bb, obj) {
        return (obj || new LegTweaksTmpChange()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsLegTweaksTmpChange(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new LegTweaksTmpChange()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    floorClip() {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : null;
    }
    skatingCorrection() {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : null;
    }
    toeSnap() {
        const offset = this.bb.__offset(this.bb_pos, 8);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : null;
    }
    footPlant() {
        const offset = this.bb.__offset(this.bb_pos, 10);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : null;
    }
    static startLegTweaksTmpChange(builder) {
        builder.startObject(4);
    }
    static addFloorClip(builder, floorClip) {
        builder.addFieldInt8(0, +floorClip, 0);
    }
    static addSkatingCorrection(builder, skatingCorrection) {
        builder.addFieldInt8(1, +skatingCorrection, 0);
    }
    static addToeSnap(builder, toeSnap) {
        builder.addFieldInt8(2, +toeSnap, 0);
    }
    static addFootPlant(builder, footPlant) {
        builder.addFieldInt8(3, +footPlant, 0);
    }
    static endLegTweaksTmpChange(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createLegTweaksTmpChange(builder, floorClip, skatingCorrection, toeSnap, footPlant) {
        LegTweaksTmpChange.startLegTweaksTmpChange(builder);
        if (floorClip !== null)
            LegTweaksTmpChange.addFloorClip(builder, floorClip);
        if (skatingCorrection !== null)
            LegTweaksTmpChange.addSkatingCorrection(builder, skatingCorrection);
        if (toeSnap !== null)
            LegTweaksTmpChange.addToeSnap(builder, toeSnap);
        if (footPlant !== null)
            LegTweaksTmpChange.addFootPlant(builder, footPlant);
        return LegTweaksTmpChange.endLegTweaksTmpChange(builder);
    }
    unpack() {
        return new LegTweaksTmpChangeT(this.floorClip(), this.skatingCorrection(), this.toeSnap(), this.footPlant());
    }
    unpackTo(_o) {
        _o.floorClip = this.floorClip();
        _o.skatingCorrection = this.skatingCorrection();
        _o.toeSnap = this.toeSnap();
        _o.footPlant = this.footPlant();
    }
}
exports.LegTweaksTmpChange = LegTweaksTmpChange;
class LegTweaksTmpChangeT {
    constructor(floorClip = null, skatingCorrection = null, toeSnap = null, footPlant = null) {
        this.floorClip = floorClip;
        this.skatingCorrection = skatingCorrection;
        this.toeSnap = toeSnap;
        this.footPlant = footPlant;
    }
    pack(builder) {
        return LegTweaksTmpChange.createLegTweaksTmpChange(builder, this.floorClip, this.skatingCorrection, this.toeSnap, this.footPlant);
    }
}
exports.LegTweaksTmpChangeT = LegTweaksTmpChangeT;
